@if (Config.domain) {
  @if (location.path().startsWith('/' + RouteUtil.DASHBOARD_MODULE)) {
    <div class="d-flex flex-column justify-content-between vh-100">
      <div class="col-12">
        <app-dashboard-header></app-dashboard-header>
      </div>
    </div>
  } @else {
    <div class="d-flex flex-column justify-content-between h-100">
      <div class="col-12 h-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
} @else {
  Loading
}
@if (updateAvailable) {
  <div class="update-banner">
    <p class="m-3">🎉 نسخه‌ی جدید سایت در دسترس است!</p>
    <p class="m-3">برای استفاده از امکانات جدید، لطفاً صفحه را به‌روزرسانی کنید 🌟</p>
    <button (click)="reload()">به‌روزرسانی صفحه</button>
  </div>
}
